// extracted by mini-css-extract-plugin
export var externalLink = "_c1-0";
export var internalLinkLabel = "_c1-1";